(ns ui.view.survey.timeseries-table
    (:require [clojure.edn :as edn]
              [clojure.string :as string]
              [common.localization :as loc]
              [common.number-format :as number-format]
              [common.schema.data-types :as data-types]
              [common.util :as cu]
              [oops.core :as oops]
              [re-frame.core :as rf]
              [reagent.core :as r]
              [ui.components.ck-editor.view :as ck-editor]
              [ui.components.grid.view :as grid]
              [ui.components.radix-ui.tooltip.view :as tooltip]
            [ui.components.rich-text.tiptap :as tiptap]
              [ui.dom-globals :as dg]
              [ui.editors.data-input :as data-input]
              [ui.event-utils :as eu]
              [ui.util :as uu]
              [ui.view.survey.event :as event]
              ["react" :as react]))

(defn value-renderer
  [{:keys [number-format]} params]
  (let [{:keys [value data]} params
        {:keys [dom-id lang data-type]} data
        numeric? (some #{data-type} data-types/numeric-data-types)]
    (r/as-element
      [:div
       {:id    dom-id
        :class (uu/cm "w-full h-full flex flex-row align-items-center"
                      (if numeric?
                        "justify-content-end"
                        "justify-content-start"))}
       [data-input/formatted-display-string
        {:data-type     data-type
         :value         value
         :min-decimals  2
         :max-decimals  2
         :number-format number-format
         :options       (:options data)
         :lang          lang}]])))

(defn printable-key?
  [eventKey]
  (and eventKey
       (= 1 (count (str eventKey)))))

(defn edit-renderer2
  [number-format questions-lookup lang params-js]
  (let [{:keys [value data onValueChange eventKey] :as params} (js->clj params-js :keywordize-keys true)
        ref-input (react/useRef nil)
        update-value (fn [v]
                       (when (fn? onValueChange)
                         (onValueChange v)))
        param-question-id (get-in data [:question-id])
        question (get questions-lookup param-question-id)
        {:keys [survey-question/data-type survey-question/options]} question
        option-type? (some #{data-type} [:data.type/keyword :data.type/ref-single :data.type/ref-multi :data.type/boolean
                                         :data.type/keyword-multi])
        single-type? (some #{data-type} [:data.type/keyword :data.type/ref-single :data.type/boolean])
        resolved-options (concat (when-not (cu/blank-value? value)
                                   [{:value nil
                                     :label (loc/tr :clear-select-option-label nil lang)}])
                                 (if (= data-type :data.type/boolean)
                                   [{:value true
                                     :label (loc/tr :yes nil lang)}
                                    {:value false
                                     :label (loc/tr :no nil lang)}]
                                   (->> options
                                        (sort-by :common/ord)
                                        (map (fn [opt]
                                               (let [label (:label opt)]
                                                 (if (string? label)
                                                   opt
                                                   (assoc opt :label (cond (map? label)
                                                                           (or (get label lang)
                                                                               (get label :ENG)))))))))))
        data-type-number (:data-type data)
        data-type (data-types/to-keyword-data-type data-type-number)]

    ;; componentDidMount
    (react/useEffect
      (fn []
        (let [[start-value select-all?] (case eventKey
                                          eu/KEY_BACKSPACE
                                          ["" false]
                                          eu/KEY_ENTER
                                          [value true]
                                          eu/KEY_F2
                                          [value false]
                                          ;; else
                                          (if (printable-key? eventKey)
                                            [(str eventKey) false]
                                            ;; else
                                            [nil false]))
              coerced-value (data-input/parse-value
                              {:data-type           data-type
                               :native-value        start-value
                               :option-value-lookup nil
                               :date-format         (loc/tr :date-format)
                               :number-format       number-format})
              init-value (or coerced-value start-value "")]
          ;(js/console.log "Set start value " eventKey ":" (count (str eventKey)) " => " start-value " > " (type start-value) " < " coerced-value " <<< " (type coerced-value))
          (update-value init-value)
          (let [e-input (.-current ref-input)]
            (when e-input
              (dg/set-value! e-input init-value)

              ;(js/console.log "FOCUS AND SELECT : " coerced-value " > " (dg/dom-value e-input))
              (.focus e-input)
              (if select-all?
                (dg/dom-select e-input)
                (let [dom-value (dg/dom-value e-input)
                      len (if dom-value
                            (count dom-value)
                            0)]
                  (when (> len 0)
                    ;; move cursor to end
                    (dg/set-selection e-input len len)))))))
        js/undefined)
      #js [])

    #_(js/console.log "Render input")
    (let [resolved-value (cond (and option-type? single-type?)
                               (->> resolved-options
                                    (filter (fn [opt]
                                              (some #{value} [(:value opt) (pr-str (:value opt))])))
                                    (first))
                               option-type?
                               (->> resolved-options
                                    (filter (fn [opt]
                                              (some #{(:value opt) (pr-str (:value opt))} value))))
                               (= data-type :data.type/date)
                               (if (string? value)
                                 (edn/read-string value)
                                 value)
                               (nil? value)
                               eventKey
                               :else
                               value)]
      #_(js/console.log "Edit renderer v2 : " eventKey
                        "\nParams: " params
                        "\nValue : " value " << " (type value) " << " stored-value
                        "\nResolved value " resolved-value " == " (type resolved-value)
                        "\nRow data : " data
                        "\nParsed row : " (js->clj data :keywordize-keys true)
                        "\nQuestion id : " param-question-id
                        "\nQuestion : " question
                        "\nLookup : " questions-lookup)
      (r/as-element
        [:div
         {:style {:width      (str (:editor-width params) "px")
                  :background "white"}}
         [data-input/view
          {:input-ref     ref-input
           :editor-type   (case data-type
                            :data.type/boolean :editor.type/select
                            nil)
           :data-type     (case data-type
                            :data.type/boolean :data.type/keyword
                            data-type)
           :number-format number-format
           :class         "w-full"
           :variant       :borderless
           :full-width?   true
           :auto-focus?   false
           :show-clear?   true
           :placeholder   (if (some #{data-type} [:data.type/ref-single :data.type/ref-multi :data.type/keyword :data.type/keyword-multi])
                            (loc/tr :select-placeholder nil lang)
                            (loc/tr data-type nil lang))
           :value         resolved-value
           :options       (->> resolved-options
                               (map (fn [opt]
                                      (assoc opt :value (pr-str (:value opt))))))
           :on-change     (fn [new-value]
                            (try (onValueChange new-value)
                                 (catch js/Object o
                                   (js/console.log "onValueChange error : " o))))
           :on-blur       (fn [new-value]
                            (try (onValueChange new-value)
                                 (catch js/Object o
                                   (js/console.log "onValueChange error : " o))))}]]))))

(defn label-cell-renderer
  [{:keys [label info data-unit]}]
  [:div
   {:class "w-full h-full flex justify-between items-center gap-2"}
   [:div
    {:class "w-4 shrink-0 grow-o flex"}
    (when info
      (when-not (cu/blank-value? info)
        [tooltip/view
         {:side :right}
         [:i.fal.fa-info-circle.text-complement-regular-text-paler]
         [:div
          {:class "bg-base-regular max-w-64"}
          [ck-editor/viewer
           (str "<p><strong>" (string/upper-case label) "</strong></p>"
                (if (string/starts-with? info "<")
                  info
                  (str "<p>" info "</p>")))]]]))]
   [:div
    {:class "flex-auto line-clamp-2"}
    label]
   [:div
    {:class "h-full"}
    (when data-unit
      [:span
       {:class "p-2 h-full flex items-center items-center gap-2 text-xs text-complement-regular-text font-normal whitespace-nowrap border-l border-solid border-complement-regular-border"}
       data-unit])]])

(defn question-col-def
  [_question-min-width _doc-width]
  {:field        "question"
   :headerName   ""
   :pinned       "left"
   :wrapText     true
   :resizable    true
   :autoHeight   true
   :maxWidth     350
   :cellRenderer (fn [params-js]
                   (let [params (js->clj params-js :keywordize-keys true)
                         label (get-in params [:data :label])]
                     ;                     (js/console.log "Header : " params)
                     (r/as-element [:div
                                    {:class "flex flex-row gap-4"}
                                    [:div
                                     {:class "flex flex-auto leading-relaxed items-center py-2 gap-2"}
                                     label
                                     (when-let [info (get-in params [:data :info])]
                                       (when-not (cu/blank-value? info)
                                         [tooltip/view
                                          {:side :right}
                                          [:i.fal.fa-info-circle.text-complement-regular-text-paler]
                                          [:div
                                           {:class "bg-base-regular text-base-regular-text max-w-64"}
                                           [:div
                                            {:class "[&_.ProseMirror]:py-0 [&_.ProseMirror]:border-0 [&_.ProseMirror]:bg-transparent"}
                                            [tiptap/viewer
                                             {:value (str "<p><strong>" (string/upper-case label) "</strong></p>"
                                                          (if (string/starts-with? info "<")
                                                            info
                                                            (str "<p>" info "</p>")))
                                              :styles {:backgroundColor "transparent"}}]]]]))]
                                    (when-let [data-unit (get-in params [:data :data-unit])]
                                      [:div
                                       {:class "flex whitespace-nowrap"}
                                       data-unit])]
                                   #_(let [label (get-in question [:survey-question/label-translations lang])]
                                       [:div
                                        {:class "w-full h-full flex justify-between items-center gap-2"}
                                        [:div
                                         {:class "w-4 shrink-0 grow-o flex"}
                                         (when-let [info (get-in question [:survey-question/info-translations lang])]
                                           (when-not (cu/blank-value? info)
                                             [tooltip/view
                                              {:side :right}
                                              [:i.fal.fa-info-circle.text-complement-regular-text-paler]
                                              [:div
                                               {:class "bg-base-regular max-w-64"}
                                               [ck-editor/viewer
                                                (str "<p><strong>" (string/upper-case label) "</strong></p>"
                                                     (if (string/starts-with? info "<")
                                                       info
                                                       (str "<p>" info "</p>")))]]]))]
                                        [:div
                                         {:class "flex-auto line-clamp-2"}
                                         label]
                                        [:div
                                         {:class "h-full"}
                                         (when-let [data-unit (:survey-question/data-unit question)]
                                           [:span
                                            {:class "p-2 h-full flex items-center items-center gap-2 text-xs text-complement-regular-text font-normal whitespace-nowrap border-l border-solid border-complement-regular-border"}
                                            data-unit])]]))))
   :cellClass    "font-semibold"})

(defn response-col-def
  [{:keys [survey-id number-format thousand-separator decimal-separator series-index series-column]}]
  ;(js/console.log "Col : " args)
  {:field        (str "resp-" series-index)
   :headerName   (:label series-column)
   :flex         1
   :maxWidth     300
   :minWidth     160
   :cellDataType false
   :valueSetter  (fn [params-js]
                   (let [{:keys [data newValue oldValue]} (js->clj params-js :keywordize-keys true)
                         {:keys [data-type option-value-lookup id]} data
                         formattedValue (if-not (some #{data-type} [:data.type/currency-value :data.type/number])
                                          newValue
                                          (-> newValue
                                              (string/replace (str thousand-separator) "")
                                              (string/replace (str decimal-separator) ".")))
                         parsed-value (data-input/parse-value
                                        {:data-type           (data-types/to-keyword-data-type data-type)
                                         :native-value        formattedValue
                                         :option-value-lookup option-value-lookup
                                         :date-format         nil
                                         :number-format       number-format})
                         clearedValue (if (and (some #{data-type} [:data.type/currency-value :data.type/integer :data.type/number])
                                               (js/isNaN parsed-value))
                                        nil
                                        parsed-value)]
                     (when (not= oldValue clearedValue)
                       (let [save-in-index (get series-column :label)]
                         (rf/dispatch [::event/on-answer-input survey-id series-index id clearedValue false save-in-index nil])
                         true))))})

(defn next-header-focus
  [_]
  (clj->js {:headerRowIndex -1
            :column         nil}))

(defn next-cell-focus
  [& params-js]
  (let [{:keys [backwards _editing api previousCellPosition nextCellPosition]} (js->clj params-js :keywordize-keys true)
        last-row-index (oops/ocall api "getLastDisplayedRowIndex")
        columns (oops/ocall api "getColumns")
        last-column (last columns)
        first-column (->> columns
                          (filter (fn [column]
                                    (string/starts-with? (str (oops/oget column "colId")) "resp-")))
                          (first))
        previous-row-index (:rowIndex previousCellPosition)
        next-row-index (:rowIndex nextCellPosition)
        next-cell-column (:column nextCellPosition)
        res (cond (nil? previous-row-index)
                  {:rowIndex  0
                   :rowPinned nil
                   :column    first-column}
                  (nil? next-cell-column)
                  {:rowIndex  -1
                   :rowPinned nil
                   :column    nil}
                  :else
                  (let [next-cell-colId (oops/oget next-cell-column "colId")
                        resp-col? (string/starts-with? (str next-cell-colId) "resp-")
                        edit-next (if resp-col?
                                    nextCellPosition
                                    (if backwards
                                      (if (zero? next-row-index)
                                        {:rowIndex  -1
                                         :column    nil
                                         :rowPinned nil}
                                        {:rowIndex  (dec next-row-index)
                                         :column    last-column
                                         :rowPinned nil})
                                      (if (not= next-row-index previous-row-index)
                                        {:rowIndex  next-row-index
                                         :column    first-column
                                         :rowPinned nil}
                                        {:rowIndex  last-row-index
                                         :column    last-column
                                         :rowPinned nil})))]
                    edit-next))]
    (clj->js res)))

(defn view
  [{:keys [survey-id thousand-separator decimal-separator number-format col-series-min-width questions-lookup lang columns question-min-width table-data]}]
  (let [doc-width (oops/oget (dg/body) "clientWidth")
        column-defs (vec (concat [(question-col-def question-min-width doc-width)]
                                 (->> (range 0 (count columns))
                                      (map (fn [series-index]
                                             (response-col-def {:survey-id            survey-id
                                                                :number-format        number-format
                                                                :thousand-separator   thousand-separator
                                                                :decimal-separator    decimal-separator
                                                                :lang                 lang
                                                                :questions-lookup     questions-lookup
                                                                :col-series-min-width col-series-min-width
                                                                :series-index         series-index
                                                                :series-column        (nth columns series-index)}))))))]
    ; (js/console.log "Col def : " column-defs)
    [:div
     [grid/ag-grid
      {:theme                         grid/theme-quartz
       :rowData                       table-data
       :columnDefs                    column-defs
       :domLayout                     :autoHeight
       :suppressContextMenu           true
       :suppressRowTransform          true
       :suppressRowHoverHighlight     true
       :rowBuffer                     100                   ;; Keep all rows in a buffer
       :pinnedTopRowData              []
       :suppressLastEmptyLineOnPaste  true
       :stopEditingWhenCellsLoseFocus true
       :getRowId                      (fn [data-js]
                                        (str (oops/oget data-js "data.id")))
       :autoSizeStrategy              {:type            "fitGridWidth",
                                       :defaultMinWidth 100,
                                       :columnLimits    [{:colId    "question"
                                                          :minWidth 400}]}
       :processCellFromClipboard      (fn [params-js]
                                        (let [params (js->clj params-js :keywordize-keys true)
                                              {:keys [value node]} params
                                              data-type-int (-> node
                                                                (oops/oget "data")
                                                                (oops/oget "data-type"))
                                              data-type (data-types/to-keyword-data-type data-type-int)
                                              res (if-not (some #{data-type} [:data.type/currency-value])
                                                    value
                                                    (-> value
                                                        (string/replace (str thousand-separator) "")
                                                        (string/replace (str decimal-separator) ".")))
                                              invalid?      ;(and
                                              ;; (= "number" cellDataType)
                                              ;;TODO: Must configure data type in col defs
                                              (number-format/find-non-numeric-chars res) ;)
                                              parsed (edn/read-string res)]
                                          (if-not invalid?
                                            parsed
                                            js/NaN)))       ;"autoHeight"
       :defaultColDef                 {:sortable                 false
                                       :filter                   false
                                       :cellClass                "absolute"
                                       :resizable                true
                                       :singleClickEdit          false
                                       :suppressKeyboardEvent    nil #_(fn [params-js]
                                                                         (grid-suppress-key questions-lookup params-js))
                                       ;:cellEditor               (edit-renderer number-format questions-lookup lang)
                                       :cellEditor               (partial edit-renderer2 number-format questions-lookup lang)
                                       :editable                 (fn [params]
                                                                   (not (some #{(oops/oget params "column.colId")} ["section" "question"])))
                                       :suppressHeaderMenuButton true
                                       :suppressMovable          true
                                       :processCellFromClipboard (fn [params-js]
                                                                   (let [params (js->clj params-js :keywordize-keys true)]
                                                                     (str "Pasted " (pr-str (:data params)))))
                                       :cellRenderer             (fn [params-js]
                                                                   (let [params (js->clj params-js :keywordize-keys true)
                                                                         {:keys [data column]} params
                                                                         column-id (oops/oget column "colId")]
                                                                     (r/as-element
                                                                       [:div
                                                                        (case column-id
                                                                          "question" [label-cell-renderer data]
                                                                          [value-renderer {:number-format number-format} params])])))}
       :tabToNextCell                 next-cell-focus
       :tabToNextHeader               next-header-focus}]]))
